module.exports = __webpack_public_path__ + "img/ape.ce9f6f15.png";